const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user timeline component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
  */
app.directive('copyButton', ['$timeout',function ($timeout) {
    return {
      restrict: 'E',
      scope: {
        tooltip: '=?',
        inputvalue: '=?'
      },
      template: require('../../templates/directives/copy-button.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.tooltipText = $scope.tooltip ? $scope.tooltip : '';
        self.initialize = function(){
          self.copyID = function(e){
            e.stopPropagation();
            e.target.nextElementSibling.select();
            try {
              var successful = document.execCommand('copy');
              var msg = successful ? 'successful' : 'unsuccessful';
              if(msg === 'successful'){
                self.tooltipText = 'Copied!';
                $timeout(function(){
                  self.tooltipText = $scope.tooltip ? $scope.tooltip : '';
                },5000);
              }
            } catch(err) {
              console.log('unable to copy');
            }
          };
        };
        self.initialize();
      }],
      controllerAs: 'copybutton'
    };
  }]);

